import { MetaPath } from 'util/metaPath'
import { AgendamentoDia } from 'view/atendimentos/types/AgendamentoDia'

import { TipoPreNatal } from '../pre-natal/model-preNatal'
import { SoapSection } from '../SoapSection'
import { FinalizacaoAtendimentoForm, FinalizacaoAtendimentoFormModel } from './FinalizacaoAtendimentoForm'
import { ObrigatoriedadesParticipacao } from './util'

export interface FinalizacaoAtendimentoSectionProps {
  name: MetaPath<FinalizacaoAtendimentoFormModel>
  atendimentoId: ID
  profissionalId?: ID
  agendamentoAtendimentoId?: ID
  concluiAgendamento: boolean
  dataAtendimento: Instant
  agendamentosDia: ReadonlyArray<AgendamentoDia>
  isAtendimentoProcedimentos: boolean
  isAtendimentoOdonto: boolean
  tipoPreNatal?: TipoPreNatal
  isRegistroTardio: boolean
  obrigatoriedadesParticipacao: ObrigatoriedadesParticipacao
}

export function FinalizacaoAtendimentoSection(props: FinalizacaoAtendimentoSectionProps) {
  return (
    <SoapSection initialIcon='checkCircleFilled' title='Finalização do atendimento'>
      <FinalizacaoAtendimentoForm {...props} dataTestId='FinalizacaoAtendimentoBox' />
    </SoapSection>
  )
}
